import { AlignmentType, ImageRun, Paragraph, TextRun, WidthType } from "docx";
import methodology from '../../../../../../Assests/ReportImages/methodologyDiscovery.png'


const methodologyimg = await fetch(methodology).then(response => response.blob())


const discoveryimg = new ImageRun({
    type: 'png',
    data: await methodologyimg.arrayBuffer(),
    transformation: {
        width: 600,
        height: 250
    },
});

export const methodologyTextMobile = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 300, before: 300, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The mobile application penetration testing methodology is typically based on the application security methodology. The focus shifts from traditional application security, where the primary threat is from multiple sources over the Internet. The key difference is in the client-side security, file system, hardware, and network security. Traditionally for mobile applications, an end user is in control of the device. ISECURION used the OWASP Mobile Security Project (OWASP) testing guide for conducting penetration test of the systems and applications. The testing was done to simulate as closely as possible the viewpoint of completely external attacker, the steps involved are",
            size: 24,
            color: '000000',
            italics: false,
            font: "Calibri",
        })
    ]
})

export const steps1BulletMobileOne = new Paragraph({
    text: "Discovery",
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1200, right: 600 },

    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            italics: false,
        }),
    ],
})

export const steps1BulletMobileTwo = new Paragraph({
    text: "Assessment/Analysis",
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1200, right: 600 },
    alignment: AlignmentType.JUSTIFIED,
    spacing: { line: 170, before: 300, after: 300 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            italics: false,
        }),
    ],
})

export const steps1BulletMobileThree = new Paragraph({
    text: "Exploitation",
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 170, before: 300, after: 300 },
    indent: { left: 1200, right: 600 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            italics: false,
        }),
    ],
})
export const steps1BulletMobileFour = new Paragraph({
    text: "Reporting",

    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 170, before: 300, after: 300 },
    indent: { left: 1200, right: 600 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            italics: false,
        }),
    ],
})

export const discoverymethodologyMobile = new Paragraph({
    spacing: { before: 500 },
    alignment: AlignmentType.CENTER,
    children: [discoveryimg]
})